// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ScheduleSettingDetailsFragmentDoc, InternalUserDetailFragmentDoc, TaskTradePartnerFragmentDoc } from '../../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddScheduleTaskQueryVariables = Types.Exact<{
  parentsWithTradePartners?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type AddScheduleTaskQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, enableClickToPay: boolean }>, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> };

export type ScheduleTaskPhasesQueryVariables = Types.Exact<{
  scheduleId: Types.Scalars['ID']['input'];
}>;


export type ScheduleTaskPhasesQuery = { __typename?: 'Query', schedule: { __typename?: 'Schedule', id: string, phases: Array<{ __typename?: 'SchedulePhase', id: string, name: string, globalPhase: { __typename?: 'GlobalPhase', id: string, name: string, globalSubPhases: Array<{ __typename?: 'GlobalSubPhase', id: string }> }, scheduleSubPhases: Array<{ __typename?: 'ScheduleSubPhase', id: string, name: string, globalSubPhase: { __typename?: 'GlobalSubPhase', id: string, name: string, globalPhase: { __typename?: 'GlobalPhase', id: string } } }>, interval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'] } | null | undefined }> } };

export type AddTaskPaneScheduleDetailsFragment = { __typename?: 'Schedule', id: string, parent:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Development', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
    | { __typename?: 'ScheduleTemplate', id: string }
  , scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined } | null | undefined };

export const AddTaskPaneScheduleDetailsFragmentDoc = gql`
    fragment AddTaskPaneScheduleDetails on Schedule {
  id
  parent {
    ... on HasSchedules {
      id
    }
  }
  scheduleSetting {
    ...ScheduleSettingDetails
  }
}
    ${ScheduleSettingDetailsFragmentDoc}`;
export const AddScheduleTaskDocument = gql`
    query AddScheduleTask($parentsWithTradePartners: [ID!]) {
  tradePartners(filter: {workingOn: $parentsWithTradePartners}) {
    ...TaskTradePartner
  }
  internalUsers {
    ...InternalUserDetail
  }
}
    ${TaskTradePartnerFragmentDoc}
${InternalUserDetailFragmentDoc}`;

/**
 * __useAddScheduleTaskQuery__
 *
 * To run a query within a React component, call `useAddScheduleTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddScheduleTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddScheduleTaskQuery({
 *   variables: {
 *      parentsWithTradePartners: // value for 'parentsWithTradePartners'
 *   },
 * });
 */
export function useAddScheduleTaskQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>(AddScheduleTaskDocument, options);
      }
export function useAddScheduleTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>(AddScheduleTaskDocument, options);
        }
// @ts-ignore
export function useAddScheduleTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>;
export function useAddScheduleTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddScheduleTaskQuery | undefined, AddScheduleTaskQueryVariables>;
export function useAddScheduleTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>(AddScheduleTaskDocument, options);
        }
export type AddScheduleTaskQueryHookResult = ReturnType<typeof useAddScheduleTaskQuery>;
export type AddScheduleTaskLazyQueryHookResult = ReturnType<typeof useAddScheduleTaskLazyQuery>;
export type AddScheduleTaskSuspenseQueryHookResult = ReturnType<typeof useAddScheduleTaskSuspenseQuery>;
export type AddScheduleTaskQueryResult = Apollo.QueryResult<AddScheduleTaskQuery, AddScheduleTaskQueryVariables>;
export const ScheduleTaskPhasesDocument = gql`
    query ScheduleTaskPhases($scheduleId: ID!) {
  schedule(id: $scheduleId) {
    id
    phases {
      id
      name
      globalPhase {
        id
        name
        globalSubPhases {
          id
        }
      }
      scheduleSubPhases {
        id
        name
        globalSubPhase {
          id
          name
          globalPhase {
            id
          }
        }
      }
      interval {
        startDate
        endDate
      }
    }
  }
}
    `;

/**
 * __useScheduleTaskPhasesQuery__
 *
 * To run a query within a React component, call `useScheduleTaskPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTaskPhasesQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useScheduleTaskPhasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables> & ({ variables: ScheduleTaskPhasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>(ScheduleTaskPhasesDocument, options);
      }
export function useScheduleTaskPhasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>(ScheduleTaskPhasesDocument, options);
        }
// @ts-ignore
export function useScheduleTaskPhasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>;
export function useScheduleTaskPhasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTaskPhasesQuery | undefined, ScheduleTaskPhasesQueryVariables>;
export function useScheduleTaskPhasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>(ScheduleTaskPhasesDocument, options);
        }
export type ScheduleTaskPhasesQueryHookResult = ReturnType<typeof useScheduleTaskPhasesQuery>;
export type ScheduleTaskPhasesLazyQueryHookResult = ReturnType<typeof useScheduleTaskPhasesLazyQuery>;
export type ScheduleTaskPhasesSuspenseQueryHookResult = ReturnType<typeof useScheduleTaskPhasesSuspenseQuery>;
export type ScheduleTaskPhasesQueryResult = Apollo.QueryResult<ScheduleTaskPhasesQuery, ScheduleTaskPhasesQueryVariables>;